import React, { useState, useEffect } from 'react';
import ScrollToTopIcon from "./Icons/ScrollToTopIcon";

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, [isVisible]);

    return (
        <button
            onClick={scrollToTop}
            className={`scroll-to-top-btn ${isVisible ? 'show' : 'hide'}`}
        >
            <ScrollToTopIcon />
        </button>
    );
};

export default ScrollToTopButton;